export const fromLead = lead => {
  const {
    name,
    contactFirstName,
    contactLastName,
    email,
    website,
    phone,
    mobilePhone,
    officePhone,
    company,
    address,
    address2,
    followUpDate,
    owner,
    city,
    region,
    zipCode,
    country,
    title,
    status,
    source,
    state,
    tags,
    about
  } = lead

  return {
    name,
    contactLastName,
    contactFirstName,
    email,
    phone,
    mobilePhone,
    officePhone,
    company,
    website,
    followUpDate,
    address,
    address2,
    city,
    region,
    zipCode,
    country,
    title,
    ...(owner && { assigneeId: owner.value }),
    ...(status && { status: { code: status.value } }),
    ...(source && { source: { code: source.value } }),
    ...(state && { state: { code: state.value } }),
    ...(tags && { tags: tags.map(tag => ({ code: tag.value })) }),
    about
  }
}

const toSelectItem = item => {
  if (!item) return null
  return { value: item.code, label: item.name }
}

const toSelectItems = items => items?.map(item => toSelectItem(item)) ?? []

export const toLead = lead => ({
  ...lead,
  owner: lead.assigneeId,
  status: toSelectItem(lead.status),
  source: toSelectItem(lead.source),
  state: toSelectItem(lead.state),
  tags: toSelectItems(lead.tags)
})

export const toEmailContacts = contacts =>
  contacts
    .filter(contact => contact.email)
    .map(contact => ({
      id: contact.id,
      firstName: contact.contactFirstName,
      lastName: contact.contactLastName,
      email: contact.email
    }))
